import { EventDay } from '@/types/EventDay.ts'
import { FunctionComponent } from 'react'
import Dialog from '@/components/_custom/Dialog/Dialog.tsx'
import { useTranslation } from 'react-i18next'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader.tsx'
import DialogBody from '@/components/_custom/DialogBody/DialogBody.tsx'
import styles from './confirmDeleteEventDayDialog.module.scss'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon.tsx'
import { Close, Delete } from '@mui/icons-material'
import { useMutation } from '@apollo/client'
import { DELETE_EVENT_DAY } from '@/modules/API/daycare/eventDayHandler.ts'
import { useNotification } from '@/modules/context/NotificationContext.tsx'

interface ConfirmDeleteEventDayProps {
    open: boolean
    handleClose: () => void
    daycareId: number
    event: EventDay
    refetchAllEvents: () => Promise<void>
}

const ConfirmDeleteEventDayDialog: FunctionComponent<ConfirmDeleteEventDayProps> = ({
    open,
    handleClose,
    daycareId,
    event,
    refetchAllEvents
}: ConfirmDeleteEventDayProps) => {
    const { t } = useTranslation()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [deleteOneEventDay] = useMutation(DELETE_EVENT_DAY, {
        variables: {
            daycare_id: daycareId,
            event_id: event.id
        },
        onCompleted: () => {
            refetchAllEvents()

            showNotificationSuccess(t('eventDayDeleted'))
            handleClose()
        },
        onError: () => {
            showNotificationError(t('eventDayNotDeleted'))
            handleClose()
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose} className={styles.Dialog}>
            <DialogHeader title={t('deleteEventDay')} />
            <DialogBody className={styles.DialogBody}>
                <p className={styles.Text}>{t('deleteEventDayMessage')}</p>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('yes')}
                        customIcon={<Delete />}
                        onClick={deleteOneEventDay}
                        className={styles.Button}
                    />
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('no')}
                        customIcon={<Close />}
                        onClick={handleClose}
                        className={styles.Button}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default ConfirmDeleteEventDayDialog
